export default "__VITE_ASSET__4oVL1U25__"